import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Blog } from 'src/app/models/article';
import { ArticleService } from 'src/app/pages/articles/services/article.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-news',
  templateUrl: './our-news.component.html',
  styleUrls: ['./our-news.component.css'],
})
export class OurNewsComponent {
  @Input() language!: string;
  @ViewChild('carouselTrack') carouselTrack!: ElementRef;

  articles: Blog[] = [];
  isLoading = true;
  lang: string = 'ar';
  activeIndex = 0;

  private touchStartX = 0;
  private touchDeltaX = 0;

  constructor(
    private articleService: ArticleService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.lang = this.route.snapshot.paramMap.get('lang') ?? 'ar';
    this.articleService.getAllArticles().subscribe({
      next: (articles) => {
        this.articles = articles
          .filter((a) => a.status == 'published')
          .map((a) => ({
            ...a,
            imageUrl: environment.baseURL + a.imageUrl,
          }));
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  getArticleUrl(article: Blog): string {
    return `/${this.lang}/articles/${article.blogId}`;
  }

  goToSlide(index: number): void {
    this.activeIndex = index;
    const slideWidth =
      this.carouselTrack.nativeElement.querySelector('.carousel-slide')
        ?.offsetWidth ?? 0;
    const gap = 12;
    // positive direction for RTL
    this.carouselTrack.nativeElement.style.transform = `translateX(${index * (slideWidth + gap)}px)`;
  }

  onTouchStart(e: TouchEvent): void {
    this.touchStartX = e.touches[0].clientX;
    this.touchDeltaX = 0;
  }

  onTouchMove(e: TouchEvent): void {
    this.touchDeltaX = e.touches[0].clientX - this.touchStartX;
  }

  onTouchEnd(): void {
    if (this.touchDeltaX > 50 && this.activeIndex < this.articles.length - 1) {
      this.goToSlide(this.activeIndex + 1);
    } else if (this.touchDeltaX < -50 && this.activeIndex > 0) {
      this.goToSlide(this.activeIndex - 1);
    }
  }

  get isMobile(): boolean {
    return window.innerWidth <= 575;
  }
}
